import { PredefinedSetValueFunctions } from './types';
import { t } from 'i18next';
import type Joi from 'joi';
import { Children, ComponentType, ReactNode } from 'react';

/**
 * Gets only specified types children.
 * @param children - React children.
 * @param types - Array of React component types.
 * @returns An array of React nodes.
 */
type TGetChildrenResults = {
  requestedElements: Record<string, ReactNode[]>;
  otherElements: ReactNode[];
};

/**
 * Gets only specified types children.
 * @param children - React children.
 * @param types - Array of React component types.
 * @returns An array of React nodes.
 */
export const getChildren = (children: ReactNode, types: Array<ComponentType<any>>): TGetChildrenResults => {
  const results: TGetChildrenResults = {
    requestedElements: {},
    otherElements: []
  };
  for (const child of Children.toArray(children)) {
    if ((child as any).type && types.some((type) => (child as any).type === type)) {
      if (!results.requestedElements[(child as any).type]) {
        results.requestedElements[(child as any).type] = [];
      }
      results.requestedElements[(child as any).type].push(child);
    } else {
      results.otherElements.push(child);
    }
  }
  return results;
};

export const PREDEFINED_SET_VALUE_FUNCTIONS: Record<PredefinedSetValueFunctions, (value: any) => any> = {
  'event-target-value': (event) => event.target.value,
  'event-target-checked': (event) => event.target.checked,
  identity: (value) => value
};

export const getJoiItemErrorMessage = (error: Joi.ValidationErrorItem): string => {
  const COMMON_ERROR_TYPES_MESSAGES: Record<string, string> = {
    'any.required': t('settings:shared.errors.required-field'),
    'string.empty': t('settings:shared.errors.required-field')
  };

  return COMMON_ERROR_TYPES_MESSAGES[error.type] || error.message;
};
